import Feedback from 'actions/feedback';

export default Feedback.createReducer();